import './Loadding.css'
const Loadding =(props)=>{
    return(
        <div className="lds-facebook"><div></div><div></div><div></div></div>
    )

}
export default Loadding;